export enum EVENT_NAME {
  CONFIGURED_FORM_ELEMENTS_MOUSE_ENTER = 'CONFIGURED_FORM_ELEMENTS_MOUSE_ENTER',
  CONFIGURED_FORM_ELEMENTS_MOUSE_LEAVE = 'CONFIGURED_FORM_ELEMENTS_MOUSE_LEAVE',
  CONFIGURED_FORM_TOGGLE_OPENED_CONTAINERS = 'CONFIGURED_FORM_TOGGLE_OPENED_CONTAINERS',
  CONFIGURED_FORM_HAS_OPENED_CONTAINER = 'CONFIGURED_FORM_HAS_OPENED_CONTAINER',
  DIALOG_WINDOW_CHANGE_POSITION = 'DIALOG_WINDOW_CHANGE_POSITION',
  DIALOG_WINDOW_CHANGE_SIZE = 'DIALOG_WINDOW_CHANGE_SIZE',
  DIALOG_WINDOW_CHANGE_FULLSCREEN_MODE = 'DIALOG_WINDOW_CHANGE_FULLSCREEN_MODE',
  CHECKBOX_IN_COLUMN_FOR_SEARCHING = 'CHECKBOX_IN_COLUMN_FOR_SEARCHING',
  GLOBAL_CHECKBOX_IN_COLUMN = 'GLOBAL_CHECKBOX_IN_COLUMN',
  ALL_CHECKBOXES_IN_COLUMN = 'ALL_CHECKBOXES_IN_COLUMN',
  CHANGE_VARIABLE_VALUE = 'CHANGE_VARIABLE_VALUE',
  ON_ROW_SELECTION = 'ON_ROW_SELECTION',
  RETURN_TO_TIMELINE = 'RETURN_TO_TIMELINE',
  RELOAD_GANTT = 'RELOAD_GANTT',
  EDIT_GANTT_CONFIG = 'EDIT_GANTT_CONFIG',
  RETURN_TO_GANTT = 'RETURN_TO_GANTT',
}

export type EventListener<T = any> = (data: T) => void

type EventData = unknown

export const subscribe = (eventName: EVENT_NAME, listener: EventListener) => {
  document.addEventListener(eventName, listener)
}

export const unsubscribe = (eventName: EVENT_NAME, listener: EventListener) => {
  document.removeEventListener(eventName, listener)
}

export const publish = (eventName: EVENT_NAME, data?: EventData) => {
  const event = new CustomEvent(eventName, { detail: data })
  document.dispatchEvent(event)
}

export class LocalEventBus {
  private target = new EventTarget()
  private listeners = new Map<string, Map<EventListener, EventListener>>()

  subscribe<T = any>(eventName: string, listener: EventListener<T>) {
    const handler = (e: Event) => {
      listener(e as CustomEvent<T>)
    }

    this.target.addEventListener(eventName, handler)

    if (!this.listeners.has(eventName)) {
      this.listeners.set(eventName, new Map())
    }
    this.listeners.get(eventName)!.set(listener, handler)
  }

  unsubscribe<T = any>(eventName: string, listener: EventListener<T>) {
    const handler = this.listeners.get(eventName)?.get(listener)
    if (handler) {
      this.target.removeEventListener(eventName, handler)
      this.listeners.get(eventName)!.delete(listener)
    }
  }

  publish<T = any>(eventName: string, data: T) {
    this.target.dispatchEvent(new CustomEvent(eventName, { detail: data }))
  }
}
